import { InputNumber, Tooltip } from 'antd';
import React from 'react';

interface DeliveryOption {
  label: string;
  availableCount: number; // Raw API amount for input limits
  displayRemaining?: number; // Smart allocation remaining for display
  quantity: number;
  disabled?: boolean;
}

interface DeliveryOptionsProps {
  options: DeliveryOption[];
  onQuantityChange: (index: number, newQuantity: number) => void;
}

export const DeliveryOptions: React.FC<DeliveryOptionsProps> = ({ options, onQuantityChange }) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
        {options.map((option, index) => (
          <div
            key={index}
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              gap: '4px'
            }}>
            <span style={{ fontWeight: '500', fontSize: '12px', minWidth: '30px' }}>{option.label}</span>
            <Tooltip title={`Remaining after smart allocation for ${option.label} delivery option`}>
              <span style={{ color: '#6b7280', fontSize: '10px', minWidth: '40px', cursor: 'help' }}>({option.displayRemaining ?? option.availableCount})</span>
            </Tooltip>
            <Tooltip title={`Enter quantity for ${option.label}. Raw available: ${option.availableCount} units`}>
              <InputNumber
                min={0}
                max={option.availableCount}
                value={option.quantity}
                disabled={option.disabled}
                controls={false}
                style={{
                  width: '50px',
                  fontSize: '12px',
                  marginLeft: '20px'
                }}
                onChange={(value): void => {
                  const newValue = value ? Number(value) : 0;

                  onQuantityChange(index, Math.max(0, Math.min(newValue, option.availableCount)));
                }}
                onKeyDown={(e): void => {
                  // Allow backspace and delete even when disabled
                  if (e.key === 'Backspace' || e.key === 'Delete') {
                    e.stopPropagation();
                    onQuantityChange(index, 0);
                  }
                }}
              />
            </Tooltip>
          </div>
        ))}
      </div>
    </div>
  );
};
